import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Contact from "../components/contactForm"

const Contactame = () => {
  return (
    <Layout>
      <SEO title="Contactame" />
      <Contact />
    </Layout>
  )
}

export default Contactame
